import { useMemo, useCallback } from "react";
import { DataGrid, GridColDef, GridRenderCellParams, GridToolbar } from '@mui/x-data-grid';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import Navbar from "../../Components/Navbar";
import { Edit } from "@mui/icons-material";
import { useBranchDivisionContext } from "../../Context/BranchDivisionContext";
import { IBranchHierarchyDivisionDto } from "../../@types/branchDivision";
import BranchDivisionDialog from "./BranchDivisionDialog";
import { StyledButton } from "../../Components/ui/CustomButton";

function BranchDivisionPage(): JSX.Element {
    const branchDivisionContext = useBranchDivisionContext()
    const branchDivisions = branchDivisionContext?.branchDivisions

    const handleEdit = useCallback((params: any) => {
        let curBranchDivisionDto = params.row as IBranchHierarchyDivisionDto

        branchDivisionContext?.setSelectedRegionId(curBranchDivisionDto.branchRegionId.toString());
        branchDivisionContext?.setSelectedEmployeeId(curBranchDivisionDto.managerEmployeeGuid);
        branchDivisionContext?.setSelectedDivisionId(curBranchDivisionDto.branchDivisionId.toString());
        branchDivisionContext?.setSelectedTitle(curBranchDivisionDto.title);
        branchDivisionContext?.setBranchDivisionDto({
            branchDivisionId: curBranchDivisionDto.branchDivisionId,
            branchRegionId: curBranchDivisionDto.branchRegionId,
            managerEmployeeId: curBranchDivisionDto.managerEmployeeId,
            managerEmployeeGuid: curBranchDivisionDto.managerEmployeeGuid,
            title: curBranchDivisionDto.title,
            isActive: curBranchDivisionDto.isActive
        });
        branchDivisionContext?.setOpen(true);
    }, [branchDivisionContext]);

    const columns: GridColDef[] = useMemo(() => [
        {
            field: 'branchDivisionId', flex: 1, headerClassName: 'header-color', renderHeader: () => (<strong>{'Division Id'}</strong>), renderCell: (params) =>
                (<strong style={{ fontWeight: 1000 }}>{params.value}</strong>)
        }, 
        { field: 'title',flex: 1, headerClassName: 'header-color', renderHeader: () => (<strong>{'Division'}</strong>) },
        { field: 'branchRegion',flex: 1, headerClassName: 'header-color', renderHeader: () => (<strong>{'Region'}</strong>)},
        { field: 'branchRegionId',flex: 1, headerClassName: 'header-color', renderHeader: () => (<strong>{'Region Id'}</strong>) },
        { field: 'isActive',flex: 1, headerClassName: 'header-color', renderHeader: () => (<strong>{'Is Active'}</strong>)},
        { field: 'manager',flex: 1, headerClassName: 'header-color', renderHeader: () => (<strong>{'Manager'}</strong>)},
        { field: 'managerEmployeeId',flex: 1, headerClassName: 'header-color', renderHeader: () => (<strong>{'Manager Employee Id'}</strong>),  hide: true },
        { field: 'managerEmployeeGuid',flex: 1, headerClassName: 'header-color', renderHeader: () => (<strong>{'Manager Employee Guid'}</strong>),  hide: true },
        {
            field: 'actions',
            headerClassName: 'header-color',
            editable: false,
            disableExport: true,
            renderHeader: () => (<strong>{'Actions'}</strong>),
            renderCell: (params: GridRenderCellParams) => (
                <Edit
                    onClick={() => {
                        handleEdit(params)
                    }}
                    sx={{ cursor: 'pointer' }}
                />
            )
        }
    ], [handleEdit]);

    const filteredRows = useMemo(
        () => branchDivisions?.filter((row) => row.isActive),
        [branchDivisions]
      );

    const handleClickOpen = () => {
        branchDivisionContext?.setOpen(true);
    };

    const handleClose = () => {
        branchDivisionContext?.setBranchDivisionDto({
            branchDivisionId: 0,
            branchRegionId: 0,
            branchRegion: '',
            manager: '',
            managerEmployeeId: 0,
            managerEmployeeGuid: '',
            title: '',
            isActive: false
        });
        branchDivisionContext?.setSelectedDivisionId((""))
        branchDivisionContext?.setSelectedEmployeeId((""))
        branchDivisionContext?.setSelectedRegionId((""))
        branchDivisionContext?.setSelectedTitle("")
        branchDivisionContext?.setOpen(false);
    };

    return (
        <>
        <Navbar />
   <div className="paper-content">
   <div className="no-padding">
   <h1 className="grid-page-title">Division Table</h1> 
   </div>
       <div style={{ height: 700, width: '100%', boxShadow:'0 3px 10px rgb(0 0 0 / 0.2)' }}>
                
                        <DataGrid
                            components={{ Toolbar: GridToolbar }}
                            sx={{
                                "& .MuiDataGrid-row:hover": {
                                    backgroundColor: "rgb(245,245,245)"
                                },
                                width: '100%',
                                padding: '2%',
                                '& .header-color': {
                                    color: '#004d84',
                                    backgroundColor: 'rgb(245,245,245)'
                                },
                            }}
                            componentsProps={{
                                toolbar: {
                                    csvOptions: { disableToolbarButton: false },
                                    printOptions: { disableToolbarButton: true },
                                    showQuickFilter: true,
                                    quickFilterProps: { debounceMs: 250 },
                                },
                            }}
                            rows={filteredRows || []}
                            getRowId={(row: IBranchHierarchyDivisionDto) => row.branchDivisionId}
                            columns={columns}
                            pageSize={10}
                            rowsPerPageOptions={[10]}
                            initialState={{
                                sorting: {
                                    sortModel: [{ field: 'branchDivisionId', sort: 'asc' }],
                                }
                            }}
                        />                   
            </div>
        <br/>
             <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <StyledButton variant="contained" onClick={handleClickOpen}> Add New Division {<AddBoxOutlinedIcon />}</StyledButton>
            </div> 
   </div>  
            <BranchDivisionDialog close={handleClose} />
        </>
    );
}

export default BranchDivisionPage;